import { css } from '@emotion/css';
import { NT30, NT90 } from '@julofinance/color-token';

export const promoCodeInputCx = css`
  & > span {
    margin: 12px 0 8px 0;
    color: ${NT90};
  }

  .promo-code-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;

    div.MuiInputBase-root:before {
      display: none;
    }

    .promo-code-input {
      flex: 1;
      margin-right: 1rem;
      border: 1px solid ${NT30};
      border-radius: 8px;
    }

    input {
      padding: 12px;
    }

    .promo-code-verify-btn {
      padding: 0.675rem;
      min-width: 7.5rem;
      .check-icon {
        margin-left: 0.5rem;
      }
    }

    &.hidden {
      visibility: hidden;
      height: 0;
    }
  }
`;
